import { IFlipperEnum } from '@r-client/data/graphql-types';
import { useGetFeatureToggleQuery } from '@r-client/shared/data/flags/remote';

/**
 * Probes the `GlobalWalletService` flipper — the single flag that routes the
 * wallet domain between the legacy monolith path (flag off) and the Warp
 * Drive path (flag on). Extracted from `useGenerateSessionJwt` so every other
 * call site shares one idiom instead of re-deriving `isWarpDriveEnabled` from
 * `useGetFeatureToggleQuery` on its own.
 *
 * Returns `false` while the underlying query is still loading, which is
 * indistinguishable from a resolved "disabled". Callers that must gate
 * behavior until the flag has actually resolved should use
 * `useIsWarpDriveEnabledWithLoadingState` instead.
 */
export const useIsWarpDriveEnabled = (): boolean => {
  const { data } = useGetFeatureToggleQuery({
    variables: { feature: IFlipperEnum.GlobalWalletService },
  });

  return !!data?.flipper?.enabled;
};
